import React from 'react';

export const MOBILE_MEDIA_QUERY = '(max-width: 767px)';

const isMatchMediaSupported = () =>
  typeof window !== 'undefined' && typeof window.matchMedia === 'function';

const getMatches = (query: string) => isMatchMediaSupported() && window.matchMedia(query).matches;

export const useMediaQuery = (query: string) => {
  const [matches, setMatches] = React.useState(() => getMatches(query));

  React.useEffect(() => {
    if (!isMatchMediaSupported()) {
      return undefined;
    }

    const mediaQueryList = window.matchMedia(query);
    const handleChange = (event: MediaQueryListEvent) => setMatches(event.matches);

    setMatches(mediaQueryList.matches);

    if (typeof mediaQueryList.addEventListener === 'function') {
      mediaQueryList.addEventListener('change', handleChange);

      return () => mediaQueryList.removeEventListener('change', handleChange);
    }

    mediaQueryList.addListener(handleChange);

    return () => mediaQueryList.removeListener(handleChange);
  }, [query]);

  return matches;
};

export const useIsMobile = () => useMediaQuery(MOBILE_MEDIA_QUERY);
